import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AccountCreationSteps,
  FinancialAccountsCreationService,
  FinancialAccountTypes,
  PatriotActNoticeService,
} from '@brightside-web/desktop/feature/financial-accounts-core';
import { ProductCodes, ProductEligibilityService } from '@brightside-web/desktop/data-access/shared';

@Component({
    selector: 'brightside-web-savings-account-intro',
    templateUrl: './savings-account-intro.component.html',
    styleUrls: ['./savings-account-intro.component.scss'],
    standalone: false
})
export class SavingsAccountIntroComponent implements OnInit {
  introReasons = [
    { key: 'SAVINGS_INTRO_ITEM_1' },
    { key: 'SAVINGS_INTRO_ITEM_2' },
    { key: 'SAVINGS_INTRO_ITEM_3' },
    { key: 'SAVINGS_INTRO_ITEM_4' },
  ];

  showLearnMore: boolean;
  learnMoreContentCount = Array(8)
    .fill(0)
    .map((x, i) => i + 1);
  learnMoreContent = [{ titleKey: 'SAVINGS_FAQ_1', bodyKey: 'SAVINGS_FAQ_1_DESC' }];

  private readonly _patriotActNotice = inject(PatriotActNoticeService);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private faCreateSvc: FinancialAccountsCreationService,
    private productEligibilitySvc: ProductEligibilityService
  ) {}

  ngOnInit(): void {}

  routeUser() {
    this._patriotActNotice.continueAfterNoticeIfNeeded(FinancialAccountTypes.SAVINGS, () => {
      this.nextStep();
    });
  }

  nextStep() {
    this.faCreateSvc.advanceStep(AccountCreationSteps.INTRO);
    this.router.navigate(['../verification'], { relativeTo: this.route });
  }

  navigateHome() {
    this.router.navigate(['home']);
  }
}
